<template>
  <img src="../../assets/image/ymlogo.png" class="logo" alt="ワイモバイル" />
</template>

<style>
.logo {
  height: 20px;
  margin-right: 20px;
  margin-left: 2px;
}
</style>
